import {BarcodeFormat, BarcodeScanner,} from '@capacitor-mlkit/barcode-scanning';
import {ref} from "vue";
import {Capacitor} from "@capacitor/core";

// Common retail product barcode formats (supermarket-style scanning).
export const PRODUCT_BARCODE_FORMATS: BarcodeFormat[] = [
  BarcodeFormat.Ean13,
  BarcodeFormat.Ean8,
  BarcodeFormat.UpcA,
  BarcodeFormat.UpcE,
  BarcodeFormat.Code128,
  BarcodeFormat.Code39,
  BarcodeFormat.QrCode
];

export const useQRScanner = () => {
  const hideEverything = ref(false);

  // const startScan = async () => {
  //   document.querySelector('body')?.classList.add('scanner-active');
  //
  //   const listener = await BarcodeScanner.addListener(
  //     'barcodeScanned',
  //     async result => {
  //       console.log(result.barcode);
  //     },
  //   );
  //
  //   // Start the barcode scanner
  //   await BarcodeScanner.startScan();
  // };
  //
  // const stopScan = async () => {
  //   document.querySelector('body')?.classList.remove('scanner-active');
  //   await BarcodeScanner.removeAllListeners();
  //   await BarcodeScanner.stopScan();
  // };

  const scanSingleBarcode = async (formats: BarcodeFormat[] = [BarcodeFormat.QrCode]): Promise<string> => {
    document.querySelector('body')?.classList.add('scanner-active');
    hideEverything.value = true;

    const supported = await isSupported();
    if (!supported) throw new Error("Not Supported");

    let permission = await checkPermissions();
    if (!permission) {
      await requestPermissions();
      permission = await checkPermissions();
    }

    if (!permission) throw new Error("No Permission");

    if (Capacitor.getPlatform() === 'android') {
      const googleModule = await isGoogleBarcodeScannerModuleAvailable();
      if (!googleModule)
        await installGoogleBarcodeScannerModule();
    }

    try {
      const { barcodes } = await BarcodeScanner.scan({formats});
      console.log(barcodes)
      hideEverything.value = false;
      document.querySelector('body')?.classList.remove('scanner-active');
      return barcodes[0].displayValue;
    } catch (e) {
      hideEverything.value = false;
      document.querySelector('body')?.classList.remove('scanner-active');
      throw new Error("Scan Failed");
    }
  };

  const isSupported = async () => {
    const {supported} = await BarcodeScanner.isSupported();
    return supported;
  };

  const openSettings = async () => {
    await BarcodeScanner.openSettings();
  };

  const isGoogleBarcodeScannerModuleAvailable = async () => {
    const {available} =
      await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
    return available;
  };

  const installGoogleBarcodeScannerModule = async () => {
    await BarcodeScanner.installGoogleBarcodeScannerModule();
  };

  const checkPermissions = async () => {
    const {camera} = await BarcodeScanner.checkPermissions();
    return camera;
  };

  const requestPermissions = async () => {
    const {camera} = await BarcodeScanner.requestPermissions();
    return camera;
  };

  return {
    scanSingleBarcode, hideEverything
  }
}
